import type { TableAlignmentType } from '@/types/alignment'
import { isRTL } from '@/composables/useDirection'
import { TableAlignment } from '@/types/alignment'
import { ColumnsObjectConfig } from '@/types/dashboard'

export function invertAlignmentForRTL(
    alignment: TableAlignmentType
): TableAlignmentType {
    if (!isRTL.value) {
        return alignment
    }
    
    if (alignment === 'left') {
        return 'right'
    } else if (alignment === 'right') {
        return 'left'
    }
    
    return alignment
}

export function hasColumnSpecificAlignment(
    config: ColumnsObjectConfig | undefined | null,
    tableColumnsAlignment?: TableAlignmentType
): boolean {
    if (!config) {
        return false
    }
    
    const globalAlignment = tableColumnsAlignment ?? TableAlignment.left
    
    for (const key in config) {
        const col = config[key]
        if (col?.align !== undefined && col.align !== globalAlignment) {
            return true
        }
    }
    
    return false
}